import InputGroup from './InputGroup';

export default InputGroup;
